module.exports = __webpack_public_path__ + "static/media/Molecules.852f1a06.svg";